import { ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setPrimarySecurity } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/report-securities/report-securities.actions';
import { setModelPortfolioToPushToIRebal } from 'ModelPortfolioApp/ts/shared/features/irebal-push-modal/state/model-portfolio-to-push-to-irebal/model-portfolio-to-push-to-irebal.action';
import { setWatchlistSecurityObject } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.actions';
import { CUSTOM_PDF_REPORTS_FEATURE, EDIT_WATCHLIST_FEATURE, LEGACY_DATA_FEATURE, LEGACY_QUOTE_PAGE_FEATURE, SCHWAB_SSO_FEATURE, STATIC_PDF_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { NOTE_SECURITY } from 'NotesApp/ts/apps/notes-app/notes.constants';
import { ACTION_DROPDOWN_CONFIG, SCHWAB_LOGO } from 'SecuritiesApp/ts/constants/security-header-control.constants';
import { ITEM_DIVIDER, ITEM_OPTION, ITEM_SUBMENU, VALUE_ADD_TO_WATCHLIST, VALUE_GENERIC_TOGGLE, VALUE_INTEGRATIONS, VALUE_NOTES, VALUE_PUSH_TO_IREBAL, VALUE_SCHWAB_SSO, VALUE_START_RTQ, } from 'SecuritiesApp/ts/constants/security-header-dropdown.constants';
import { CUSTOM_BENCHMARK_LABEL, CUSTOM_BENCHMARK_VALUE, ENHANCED_BENCHMARK_LABEL, ENHANCED_BENCHMARK_VALUE, STANDARD_BENCHMARK_LABEL, STANDARD_BENCHMARK_VALUE, SUPPORTED_ENHANCED_BENCHMARK_DETAILED_SECURITY_TYPES, } from 'SecuritiesApp/ts/features/security-header-control/constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { UtilsService } from 'Angular/services/core/utils.service';
import { StaticFileUrlService } from 'Angular/services/static-file-url.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SchwabSsoFormComponent } from 'AccountsApp/ts/features/schwab_sso_form/schwab-sso-form.component';
import { MetricAndSystemAlertsModalComponent } from 'AlertsApp/ts/features/alerts-modals/components/metric-and-system-alerts-modal/metric-and-system-alerts-modal.component';
import { SharingModalComponent } from 'Angular/features/components/modals/sharing-modal/sharing-modal.component';
import { PdfModalWrapperComponent } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/modal-wrapper/pdf-modal-wrapper.component';
import { NotesModalComponent } from 'NotesApp/ts/apps/notes-app/components/notes-modal/notes-modal.component';
import { StartRTQAssessmentModalComponent } from 'RTQApp/apps/rtq-assessment-list-app/components/start-rtq-assessment-modal/start-rtq-assessment-modal.component';
import { CustomBenchmarkSelectorModalComponent } from 'SecuritiesApp/ts/features/custom-benchmark-selector-modal/custom-benchmark-selector-modal.component';
import { AddToWatchlistModalComponent } from 'WatchlistApp/ts/features/add-to-watchlist-modal/components/add-to-watchlist-modal.component';
import { openOrCopyAssessmentLink } from 'RTQApp/features/rtq-shared/utils/rtq-assessment-utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "@ngrx/store";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "Angular/services/static-file-url.service";
import * as i5 from "Angular/services/core/urls.service";
import * as i6 from "Angular/services/core/utils.service";
import * as i7 from "../../../../../../watchlists/static/watchlists/ts/features/add-to-watchlist-modal/components/add-to-watchlist-modal.component";
import * as i8 from "AlertsApp/ts/features/alerts-modals/components/metric-and-system-alerts-modal/metric-and-system-alerts-modal.component";
import * as i9 from "@angular/common";
import * as i10 from "../custom-benchmark-selector-modal/custom-benchmark-selector-modal.component";
import * as i11 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/modal-wrapper/pdf-modal-wrapper.component";
import * as i12 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i13 from "../../../../../../model_portfolios/static/model_portfolios/ts/shared/features/irebal-push-modal/components/irebal-push-modal.component";
import * as i14 from "../../../../../../notes/static/notes/ts/apps/notes-app/components/notes-modal/notes-modal.component";
import * as i15 from "ClientManagementApp/ts/features/registration-status-update-dropdown/registration-status-update-dropdown.component";
import * as i16 from "../../../../../../accounts/static/accounts/ts/features/schwab_sso_form/schwab-sso-form.component";
import * as i17 from "../security-header-dropdown/security-header-dropdown.component";
import * as i18 from "../../../../../../../ycharts/static/ts/features/components/modals/sharing-modal/sharing-modal.component";
import * as i19 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i20 from "../../../../../../risk_tolerance_questionnaire/static/risk_tolerance_questionnaire/ts/apps/rtq-assessment-list-app/components/start-rtq-assessment-modal/start-rtq-assessment-modal.component";
import * as i21 from "../symbol-switcher/symbol-switcher.component";
import * as i22 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = (a0, a1, a2) => ({ id: a0, type: a1, name: a2 });
const _c1 = () => ({ button: "btn btn-secondary dropdown-toggle" });
const _c2 = a0 => ({ disabled: a0 });
const _c3 = a0 => ({ "disabled": a0 });
function SecurityHeaderControlComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-symbol-switcher", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("securityType", ctx_r0.security.security_type)("securityUrlIdentifier", ctx_r0.securityUrlIdentifier);
} }
function SecurityHeaderControlComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 16);
    i0.ɵɵlistener("changeHandler", function SecurityHeaderControlComponent_Conditional_3_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.updateBenchmarkType($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(7, _c1))("config", ctx_r0.BENCHMARK_TYPE_DROPDOWN_CONFIG)("customSublabel", ctx_r0.dropdownBenchmarkLabel)("customLabel", ctx_r0.dropdownTitle)("isInHeader", true)("isCollapsible", true)("selectedValue", ctx_r0.benchmarkType);
} }
function SecurityHeaderControlComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-registration-status-update-dropdown", 4);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("status", ctx_r0.selectedStatus)("registrationType", ctx_r0.registrationType)("registrationId", ctx_r0.security.id);
} }
function SecurityHeaderControlComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function SecurityHeaderControlComponent_Conditional_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.showAlertsModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-alert");
} }
function SecurityHeaderControlComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function SecurityHeaderControlComponent_Conditional_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.showSharingModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, !ctx_r0.canShare));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-share");
} }
function SecurityHeaderControlComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("click", function SecurityHeaderControlComponent_Conditional_7_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.showNotesModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-notes");
} }
function SecurityHeaderControlComponent_Conditional_8_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Watchlist");
    i0.ɵɵelementEnd();
} }
function SecurityHeaderControlComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function SecurityHeaderControlComponent_Conditional_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.addSecurityToWatchlist()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 18);
    i0.ɵɵconditionalCreate(2, SecurityHeaderControlComponent_Conditional_8_Conditional_2_Template, 2, 0, "span");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, !ctx_r0.hasEditWatchlistFeature));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-add");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showAddToWatchlistLabel ? 2 : -1);
} }
function SecurityHeaderControlComponent_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("click", function SecurityHeaderControlComponent_Conditional_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.showGenerateReportModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 18);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "Reports");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, !ctx_r0.hasGenerateReportFeature));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-overview");
} }
function SecurityHeaderControlComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-security-header-dropdown", 23);
    i0.ɵɵlistener("handler", function SecurityHeaderControlComponent_Conditional_10_Template_ycn_security_header_dropdown_handler_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.actionDropdownHandler($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("buttonClass", "btn btn-secondary dropdown-toggle user-select-none")("dropdownConfig", ctx_r0.actionDropdownConfig)("dropdownClass", "dropdown-menu-with-icons dropdown-menu-right");
} }
function SecurityHeaderControlComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-sharing-modal", 11);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("shareableItem", ctx_r0.shareableItem)("publicSharingItemType", ctx_r0.security.security_type);
} }
function SecurityHeaderControlComponent_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-pdf-modal-wrapper");
} }
function SecurityHeaderControlComponent_Conditional_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-metric-and-system-alerts-modal", 13);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("defaultOnly", ctx_r0.useGenericDataView);
} }
/**
 * SecurityHeaderControlComponent.
 *
 * Buttons and controls for the right side of the security quote header. It's called from a Django Template as a
 * bootstrapped component, so all the input must be passed in as HTML attributes.
 */
export class SecurityHeaderControlComponent {
    constructor(accountsService, eltRef, addToWatchlistStore, alertsStore, customPdfReportStore, iRebalPushStore, featureService, staticFileUrlService, urlsService, utilsService) {
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.addToWatchlistStore = addToWatchlistStore;
        this.alertsStore = alertsStore;
        this.customPdfReportStore = customPdfReportStore;
        this.iRebalPushStore = iRebalPushStore;
        this.featureService = featureService;
        this.staticFileUrlService = staticFileUrlService;
        this.urlsService = urlsService;
        this.utilsService = utilsService;
        this.USER = window.USER;
        this.benchmarkType = STANDARD_BENCHMARK_VALUE;
        this.previousBenchmarkType = STANDARD_BENCHMARK_VALUE;
        this.customBenchmarkSecurityId = '';
        this.customBenchmarkDisplayName = '';
        this.CUSTOM_BENCHMARK_VALUE = CUSTOM_BENCHMARK_VALUE;
        this.useGenericDataView = false;
        this.dropdownTitle = 'Benchmark:';
        this.dropdownBenchmarkLabel = '';
        this.sharing = null;
        this.showEnhancedBenchmarkSwitcher = false;
        this.showPushToIRebalOption = false;
        this.showStartRTQOption = false;
        this.pushToIRebalOptionDisabled = false;
        this.actionDropdownConfig = { ...ACTION_DROPDOWN_CONFIG };
        this.BENCHMARK_TYPE_DROPDOWN_CONFIG = {
            list: [
                {
                    type: 'option',
                    label: STANDARD_BENCHMARK_LABEL,
                    value: STANDARD_BENCHMARK_VALUE,
                },
                {
                    type: 'option',
                    label: ENHANCED_BENCHMARK_LABEL,
                    value: ENHANCED_BENCHMARK_VALUE,
                },
                {
                    type: 'option',
                    label: CUSTOM_BENCHMARK_LABEL,
                    value: CUSTOM_BENCHMARK_VALUE,
                },
            ],
        };
        this.BENCHMARK_TYPE_LABEL_MAP = {
            enhanced: ENHANCED_BENCHMARK_LABEL,
            standard: STANDARD_BENCHMARK_LABEL,
            custom: CUSTOM_BENCHMARK_LABEL,
        };
        this.NOTE_SECURITY = NOTE_SECURITY;
        const serializedSecurity = JSON.parse(eltRef.nativeElement.getAttribute('security'));
        this.security = { ...serializedSecurity };
        this.sharing = serializedSecurity.sharing ? { ...serializedSecurity.sharing } : null;
        this.canShare = window.USER.shareableClientGroups.length > 0 && this.sharing !== null && this.sharing.is_owner;
        this.enableNotesSharing = (eltRef.nativeElement.getAttribute('enableNotesSharing') ?? 'true') === 'true';
        this.securityUrlIdentifier = eltRef.nativeElement.getAttribute('securityUrlIdentifier');
        this.showCustomPDFReports = eltRef.nativeElement.getAttribute('showCustomPDFReports') === 'true';
        this.showShareButton = eltRef.nativeElement.getAttribute('showShareButton') === 'true';
        this.showSsoIntegrations = eltRef.nativeElement.getAttribute('showSsoIntegrations') === 'true';
        this.showAlertsButton = eltRef.nativeElement.getAttribute('showAlertsButton') === 'true';
        this.showNotesButton = eltRef.nativeElement.getAttribute('showNotesButton') === 'true';
        this.showAddToWatchlistButton = eltRef.nativeElement.getAttribute('showAddToWatchlistButton') === 'true';
        this.showAddToWatchlistLabel = eltRef.nativeElement.getAttribute('showAddToWatchlistLabel') === 'true';
        this.showPushToIRebalOption = eltRef.nativeElement.getAttribute('showPushToIRebalOption') === 'true';
        this.showStartRTQOption = eltRef.nativeElement.getAttribute('showStartRTQOption') === 'true';
        this.pushToIRebalOptionDisabled = eltRef.nativeElement.getAttribute('pushToIRebalOptionDisabled') === 'true';
        this.selectedStatus = (eltRef.nativeElement.getAttribute('selectedStatus') ?? 'active');
        this.registrationType = (eltRef.nativeElement.getAttribute('registrationType') ?? 'client');
        this.showActionsDropdown = eltRef.nativeElement.getAttribute('showActionsDropdown') === 'true';
        this.hasEditWatchlistFeature = this.featureService.userHasFeatures([EDIT_WATCHLIST_FEATURE]);
        this.hasGenerateReportFeature = this.featureService.userHasSomeFeatures([
            STATIC_PDF_FEATURE,
            CUSTOM_PDF_REPORTS_FEATURE,
        ]);
        if (this.sharing)
            this.shareableItem = {
                id: Number(this.securityUrlIdentifier),
                name: this.security.security_name,
                sharing: this.sharing,
            };
        if (this.showPushToIRebalOption) {
            this.actionDropdownConfig.list.push({
                type: ITEM_OPTION,
                label: 'Push to iRebal',
                value: VALUE_PUSH_TO_IREBAL,
                icon: 'icon-folder-move',
                disabled: this.pushToIRebalOptionDisabled,
            });
        }
        if (this.showStartRTQOption) {
            this.actionDropdownConfig.list.push({
                type: ITEM_OPTION,
                label: 'Start Questionnaire',
                value: VALUE_START_RTQ,
                icon: 'icon-overview',
                disabled: false,
            });
        }
        this.setActionDropdownConfig();
    }
    ngOnInit() {
        this.accountsService
            .getUserSecurityBenchmarkPreferences(this.security.security_id)
            .subscribe((benchmarkPreference) => {
            this.customBenchmarkSecurityId = benchmarkPreference.benchmark_security_id || '';
            this.customBenchmarkDisplayName = benchmarkPreference.benchmark_name;
            if (this.customBenchmarkSecurityId) {
                this.benchmarkType = CUSTOM_BENCHMARK_VALUE;
            }
            else if (benchmarkPreference.use_enhanced_benchmark) {
                this.benchmarkType = ENHANCED_BENCHMARK_VALUE;
            }
            else {
                this.benchmarkType = STANDARD_BENCHMARK_VALUE;
            }
            this.updateDropdrownBenchmarkLabel();
        });
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.showEnhancedBenchmarkSwitcher =
                preference.show_enhanced_benchmark_switcher &&
                    SUPPORTED_ENHANCED_BENCHMARK_DETAILED_SECURITY_TYPES.includes(this.security.detailed_security_type);
            this.updateDropdrownBenchmarkLabel();
        });
        this.accountsService.useGenericData([LEGACY_QUOTE_PAGE_FEATURE]).subscribe((useGenericDataDisplay) => {
            this.useGenericDataView = useGenericDataDisplay;
        });
    }
    ngAfterViewInit() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('open_generate_report') === 'true') {
            params.delete('open_generate_report');
            const qs = params.toString();
            window.history.replaceState({}, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`);
            setTimeout(() => this.showGenerateReportModal());
        }
    }
    updateBenchmarkType(benchmarkType) {
        this.previousBenchmarkType = this.benchmarkType;
        this.benchmarkType = benchmarkType;
        this.updateDropdrownBenchmarkLabel();
        if (benchmarkType === CUSTOM_BENCHMARK_VALUE) {
            this.customBenchmarkSelectorModal.openModal(this.customBenchmarkDisplayName);
            return;
        }
        this.accountsService
            .putUserSecurityBenchmarkPreferences({
            security_id: this.security.security_id,
            use_enhanced_benchmark: benchmarkType === ENHANCED_BENCHMARK_VALUE,
            benchmark_security_id: '',
        })
            .subscribe(() => window.location.reload());
    }
    selectCustomBenchmark(result) {
        this.customBenchmarkSecurityId = result.search_id;
        this.customBenchmarkDisplayName = result.name;
        this.accountsService
            .putUserSecurityBenchmarkPreferences({
            security_id: this.security.security_id,
            use_enhanced_benchmark: false,
            benchmark_security_id: result.search_id,
        })
            .subscribe(() => window.location.reload());
    }
    cancelCustomBenchmark() {
        this.benchmarkType = this.previousBenchmarkType;
        this.updateDropdrownBenchmarkLabel();
    }
    updateDropdrownBenchmarkLabel() {
        this.dropdownBenchmarkLabel = ` ${this.BENCHMARK_TYPE_LABEL_MAP[this.benchmarkType]}`;
    }
    setActionDropdownConfig() {
        if (this.featureService.userHasSomeFeatures([LEGACY_DATA_FEATURE, LEGACY_QUOTE_PAGE_FEATURE])) {
            this.accountsService.useGenericData([LEGACY_QUOTE_PAGE_FEATURE]).subscribe((useGenericDataDisplay) => {
                this.actionDropdownConfig.list = [
                    {
                        type: ITEM_OPTION,
                        label: `Switch to ${useGenericDataDisplay ? 'Legacy' : 'Default'} View`,
                        value: VALUE_GENERIC_TOGGLE,
                        icon: 'icon-password-show',
                        disabled: false,
                    },
                    ...this.actionDropdownConfig.list,
                ];
            });
        }
        this.actionDropdownConfig.list = this.actionDropdownConfig.list.map((option) => {
            if (option.value === VALUE_ADD_TO_WATCHLIST) {
                return { ...option, disabled: !this.hasEditWatchlistFeature };
            }
            return option;
        });
        // Adds the Schwab SSO integration option to the dropdown menu configuration if the user is allowed for this
        // security.
        if (this.featureService.userHasFeatures([SCHWAB_SSO_FEATURE]) && this.showSsoIntegrations) {
            // We need to get the Cacheable SVG image.
            this.staticFileUrlService.getAbsoluteURL(SCHWAB_LOGO).subscribe((cachedUrl) => {
                this.actionDropdownConfig.list = this.actionDropdownConfig.list.concat([
                    {
                        type: ITEM_DIVIDER,
                        label: null,
                        value: null,
                        icon: null,
                    },
                    {
                        type: ITEM_SUBMENU,
                        label: 'Integrations',
                        value: VALUE_INTEGRATIONS,
                        icon: null,
                        disabled: false,
                        subMenu: [
                            {
                                type: ITEM_OPTION,
                                label: 'View in Schwab Advisor Center',
                                value: VALUE_SCHWAB_SSO,
                                logoSource: cachedUrl,
                                disabled: false,
                            },
                        ],
                    },
                ]);
            });
        }
    }
    /**
     * Opens the Sharing modal.
     */
    showSharingModal() {
        if (this.canShare)
            this.sharingModalComponent.openModal();
    }
    /**
     * Opens the Start RTQ modal.
     */
    showStartRTQModal() {
        this.startRTQAssessmentModalComponent.openModal(this.security);
    }
    handleCreatedAssessment(newAssessment) {
        const { assessment } = newAssessment;
        if (!assessment.id) {
            return;
        }
        openOrCopyAssessmentLink(assessment, this.urlsService, this.utilsService, true);
    }
    /**
     * Dispatches the action `setPrimarySecurity` to open the `Generate Report` wizard. Before that, it'll reset the
     * state with `resetAllCustomPdfReportItems` in case a previous wizard wasn't completed.
     */
    showGenerateReportModal() {
        if (!this.hasGenerateReportFeature) {
            return;
        }
        this.customPdfReportStore.dispatch(resetAllCustomPdfReportItems());
        this.customPdfReportStore.dispatch(setPrimarySecurity({
            securityId: this.security.security_id,
            securityName: this.security.security_name,
            displaySecurityID: this.security.display_security_id,
            securityType: this.security.security_type,
            isMandatory: true,
            disableEditBtn: true,
        }));
    }
    /**
     * Opens the appropriate alerts modal based on the security type.
     */
    showAlertsModal() {
        const alertObject = {
            id: Number(this.security.id),
            name: this.security.security_name,
            type: this.security.security_type,
            detailedType: this.security.detailed_security_type,
        };
        this.alertsModalComponent.openModal(alertObject);
    }
    /**
     * Opens the Notes modal.
     */
    showNotesModal() {
        this.notesModalComponent.openModal();
    }
    /**
     * Dispatches `setWatchlistSecurityObject` to open the `Add to Watchlist` modal for the current security.
     */
    addSecurityToWatchlist() {
        this.addToWatchlistStore.dispatch(setWatchlistSecurityObject({ securityObject: this.security }));
    }
    /**
     * Handler for the dropdown menu. Executes an action depending on the selected option.
     *
     * @param item: Selected item from the dropdown menu.
     */
    actionDropdownHandler(item) {
        switch (item.value) {
            case VALUE_GENERIC_TOGGLE:
                this.useGenericDataView = !this.useGenericDataView;
                this.accountsService
                    .putUserPreferences({ use_generic_data_display: this.useGenericDataView })
                    .subscribe(() => window.location.reload());
                break;
            case VALUE_NOTES:
                this.showNotesModal();
                break;
            case VALUE_ADD_TO_WATCHLIST:
                this.addSecurityToWatchlist();
                break;
            case VALUE_SCHWAB_SSO:
                this.schwabSsoFormComponent.login();
                break;
            case VALUE_PUSH_TO_IREBAL:
                this.iRebalPushStore.dispatch(setModelPortfolioToPushToIRebal({
                    modelPortfolio: {
                        name: this.security.security_name,
                        security_object: this.security,
                    },
                }));
                break;
            case VALUE_START_RTQ:
                this.showStartRTQModal();
                break;
            default:
                break;
        }
    }
}
SecurityHeaderControlComponent.ɵfac = function SecurityHeaderControlComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityHeaderControlComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.FeatureService), i0.ɵɵdirectiveInject(i4.StaticFileUrlService), i0.ɵɵdirectiveInject(i5.UrlsService), i0.ɵɵdirectiveInject(i6.UtilsService)); };
SecurityHeaderControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SecurityHeaderControlComponent, selectors: [["ycn-security-header-control"]], viewQuery: function SecurityHeaderControlComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(AddToWatchlistModalComponent, 5);
        i0.ɵɵviewQuery(PdfModalWrapperComponent, 5);
        i0.ɵɵviewQuery(SharingModalComponent, 5);
        i0.ɵɵviewQuery(SchwabSsoFormComponent, 5);
        i0.ɵɵviewQuery(StartRTQAssessmentModalComponent, 5);
        i0.ɵɵviewQuery(NotesModalComponent, 5);
        i0.ɵɵviewQuery(MetricAndSystemAlertsModalComponent, 5);
        i0.ɵɵviewQuery(CustomBenchmarkSelectorModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addToWatchlistModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pdfModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sharingModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.schwabSsoFormComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.startRTQAssessmentModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.notesModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alertsModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customBenchmarkSelectorModal = _t.first);
    } }, standalone: false, decls: 20, vars: 19, consts: [[1, "page-header-options", "col-auto"], [3, "securityType", "securityUrlIdentifier"], [1, "form-inline"], [3, "customCssClasses", "config", "customSublabel", "customLabel", "isInHeader", "isCollapsible", "selectedValue"], [3, "status", "registrationType", "registrationId"], ["ycnTooltip", "", "tooltipTitle", "Alerts", 1, "btn", "btn-secondary"], ["ycnTooltip", "", "tooltipTitle", "Share", 1, "btn", "btn-secondary", 3, "ngClass"], [1, "btn", "btn-secondary"], ["ycnTooltip", "", "tooltipTitle", "Add to Watchlist", 1, "btn", "btn-secondary", 3, "ngClass"], [1, "btn", "btn-secondary", 3, "ngClass"], [3, "buttonClass", "dropdownConfig", "dropdownClass"], [3, "shareableItem", "publicSharingItemType"], [3, "noteType", "enableSharing", "parentModelInfo"], [3, "defaultOnly"], [3, "createdAssessment"], [3, "submitHandler", "cancelHandler"], [3, "changeHandler", "customCssClasses", "config", "customSublabel", "customLabel", "isInHeader", "isCollapsible", "selectedValue"], ["ycnTooltip", "", "tooltipTitle", "Alerts", 1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], ["ycnTooltip", "", "tooltipTitle", "Share", 1, "btn", "btn-secondary", 3, "click", "ngClass"], [1, "btn", "btn-secondary", 3, "click"], ["ycnTooltip", "", "tooltipTitle", "Add to Watchlist", 1, "btn", "btn-secondary", 3, "click", "ngClass"], [1, "btn", "btn-secondary", 3, "click", "ngClass"], [3, "handler", "buttonClass", "dropdownConfig", "dropdownClass"]], template: function SecurityHeaderControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵconditionalCreate(1, SecurityHeaderControlComponent_Conditional_1_Template, 1, 2, "ycn-symbol-switcher", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵconditionalCreate(3, SecurityHeaderControlComponent_Conditional_3_Template, 1, 8, "ycn-single-select-dropdown", 3);
        i0.ɵɵconditionalCreate(4, SecurityHeaderControlComponent_Conditional_4_Template, 1, 3, "ycn-registration-status-update-dropdown", 4);
        i0.ɵɵconditionalCreate(5, SecurityHeaderControlComponent_Conditional_5_Template, 2, 1, "div", 5);
        i0.ɵɵconditionalCreate(6, SecurityHeaderControlComponent_Conditional_6_Template, 2, 4, "div", 6);
        i0.ɵɵconditionalCreate(7, SecurityHeaderControlComponent_Conditional_7_Template, 2, 1, "div", 7);
        i0.ɵɵconditionalCreate(8, SecurityHeaderControlComponent_Conditional_8_Template, 3, 5, "div", 8);
        i0.ɵɵconditionalCreate(9, SecurityHeaderControlComponent_Conditional_9_Template, 4, 4, "div", 9);
        i0.ɵɵconditionalCreate(10, SecurityHeaderControlComponent_Conditional_10_Template, 1, 3, "ycn-security-header-dropdown", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(11, SecurityHeaderControlComponent_Conditional_11_Template, 1, 2, "ycn-sharing-modal", 11);
        i0.ɵɵconditionalCreate(12, SecurityHeaderControlComponent_Conditional_12_Template, 1, 0, "ycn-pdf-modal-wrapper");
        i0.ɵɵelement(13, "ycn-add-to-watchlist-modal")(14, "ycn-schwab-sso-form")(15, "ycn-notes-modal", 12);
        i0.ɵɵconditionalCreate(16, SecurityHeaderControlComponent_Conditional_16_Template, 1, 1, "ycn-metric-and-system-alerts-modal", 13);
        i0.ɵɵelement(17, "ycn-irebal-push-modal");
        i0.ɵɵelementStart(18, "ycn-start-rtq-assessment-modal", 14);
        i0.ɵɵlistener("createdAssessment", function SecurityHeaderControlComponent_Template_ycn_start_rtq_assessment_modal_createdAssessment_18_listener($event) { return ctx.handleCreatedAssessment($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "ycn-custom-benchmark-selector-modal", 15);
        i0.ɵɵlistener("submitHandler", function SecurityHeaderControlComponent_Template_ycn_custom_benchmark_selector_modal_submitHandler_19_listener($event) { return ctx.selectCustomBenchmark($event); })("cancelHandler", function SecurityHeaderControlComponent_Template_ycn_custom_benchmark_selector_modal_cancelHandler_19_listener() { return ctx.cancelCustomBenchmark(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.security.security_type !== "indicator" ? 1 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.showEnhancedBenchmarkSwitcher ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.security.security_type === "registration" ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showAlertsButton ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showShareButton ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showNotesButton ? 7 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showAddToWatchlistButton ? 8 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showCustomPDFReports ? 9 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showActionsDropdown ? 10 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.shareableItem ? 11 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.hasGenerateReportFeature ? 12 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("noteType", ctx.NOTE_SECURITY)("enableSharing", ctx.enableNotesSharing)("parentModelInfo", i0.ɵɵpureFunction3(15, _c0, ctx.security.id, ctx.security.security_type, ctx.security.security_name ? ctx.security.security_name : ctx.security.security_id));
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.showAlertsButton ? 16 : -1);
    } }, dependencies: [i7.AddToWatchlistModalComponent, i8.MetricAndSystemAlertsModalComponent, i9.NgClass, i10.CustomBenchmarkSelectorModalComponent, i11.PdfModalWrapperComponent, i12.IconDirective, i13.IRebalPushModal, i14.NotesModalComponent, i15.RegistrationStatusUpdateDropdownComponent, i16.SchwabSsoFormComponent, i17.SecurityHeaderDropdownComponent, i18.SharingModalComponent, i19.SingleSelectDropdownComponent, i20.StartRTQAssessmentModalComponent, i21.SymbolSwitcherComponent, i22.TooltipDirective], encapsulation: 2 });
